import { getChromeStorageLocal } from "../../utils/chromeStorageLocal";

/**
 * Must match `StoreKeys.EXTENSION_INSTALLED_AT_MS` in extension-chrome (`extension_installed_at_ms`).
 */
export const EXTENSION_INSTALLED_AT_MS_STORAGE_KEY = "extension_installed_at_ms";

/** Session replay is only allowed for users who installed within this window (ms). */
export const SESSION_REPLAY_INSTALL_WINDOW_MS = 60 * 60 * 1000;

/**
 * True when chrome.storage has a first-install timestamp and the user is still within the session replay window.
 * Missing key (e.g. upgraded from an older build) → false.
 */
export async function isInstalledWithinSessionReplayWindow(): Promise<boolean> {
  const storage = getChromeStorageLocal();
  if (!storage) {
    return false;
  }
  try {
    const result = await storage.get(EXTENSION_INSTALLED_AT_MS_STORAGE_KEY);
    const installedAt = result[EXTENSION_INSTALLED_AT_MS_STORAGE_KEY];
    if (typeof installedAt !== "number" || Number.isNaN(installedAt)) {
      return false;
    }
    return Date.now() - installedAt <= SESSION_REPLAY_INSTALL_WINDOW_MS;
  } catch {
    return false;
  }
}
